var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"title"},[_vm._t("default"),(_vm.hasCount)?_c('span',{staticClass:"is-small"},[_vm._v("\n    ("+_vm._s(_vm._f("count")(_vm.items))+" "+_vm._s(_vm.itemName)+")\n  ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }